@if (type == 'countryId') {
  <mat-select
    class="mat-select-country-code mt-0 form-select-mat text-1 border-gris-1"
    (click)="reloadList()"
    (selectionChange)="selectChange($event)"
    value="{{ selectedId }}"
    (openedChange)="onDropdownOpen($event)"
    placeholder="{{ 'COMMON.Phone Country Code' | translate }}"
    [ngClass]="{
      'mobile_container_org mx-0': moduleName == 'Organization Contact',
    }"
  >
    <input
      #searchInput
      class="form-control border-0 select-input-value country-code-search-input"
      type="text"
      placeholder="{{ inputPlaceHolder }}"
      aria-label="Number"
      matInput
      (keyup)="onSearchList($event)"
    />
    @for (item of listfordisplay; track item) {
      <mat-option
        class="text-1"
        style="background-color: #ffffff"
        value="{{ item.id }}"
      >
        {{ item.name }} (+{{ item.phone_code }})
      </mat-option>
    }
  </mat-select>
}

@if (type == 'contacts') {
  <mat-select
    class="mat-select-country-code form-select-mat text-1 border-gris-1"
    (click)="reloadList()"
    (selectionChange)="selectChange($event)"
    (openedChange)="onDropdownOpen($event)"
    value="{{ selectedId }}"
  >
    <input
      #searchInput
      class="form-control border-0 select-input-value"
      type="text"
      placeholder="{{ inputPlaceHolder }}"
      aria-label="Number"
      matInput
      (keyup)="onSearchList($event)"
    />
    @for (item of listfordisplay; track item) {
      <mat-option class="text-1" value="{{ item.id }}">
        #{{ item?.merchant_customers_relations[0].customerNumber }} -
        {{ item?.firstname }}
        {{ item?.lastname }}
      </mat-option>
    }
  </mat-select>
}
